/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2V1L21lc3NhZ2Utc2VxdWVuY2UvbWVzc2FnZS10ZW1wbGF0ZS9tZXNzYWdlLXRlbXBsYXRlLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
